import { EntityProp, EntityPropList, ePropType, PropData } from '@abp/ng.components/extensible';
import { SaasTenantDto } from '@volo/abp.ng.saas/proxy';
import { eSaasComponents, SaasEntityPropContributors } from '@volo/abp.ng.saas';
import { of } from 'rxjs';

function tenantIdEntityPropContributor(propList: EntityPropList<SaasTenantDto>): void {
  const tenantIdProp = new EntityProp<SaasTenantDto>({
    type: ePropType.String,
    name: 'id',
    displayName: 'Tenant ID',
    sortable: false,
    columnWidth: 300,
    valueResolver: (data: PropData<SaasTenantDto>) => of(data.record.id ?? ''),
  });

  propList.addAfter(tenantIdProp, 'name', (prop, name) => prop.name === name);
}

export const SAAS_ENTITY_PROP_CONTRIBUTORS: SaasEntityPropContributors = {
  [eSaasComponents.Tenants]: [tenantIdEntityPropContributor],
};
